export const searchParams = {
  populate: {
    pageIcon: {
      populate: {
        icon: {
          populate: "*",
        },
        uicon: {
          populate: "*",
        },
      },
    },
    blocks: {
      on: {
        "sections.banner": {
          populate: {
            photo: {
              populate: "*",
            },
            icon: {
              populate: "*",
            },
          },
        },
        "sections.main-stories-section": {
          populate: {
            title: {
              populate: {
                titleIconSettings: {
                  populate: {
                    icon: {
                      populate: {
                        uicon: {
                          populate: "*",
                        },
                        icon: {
                          populate: "*",
                        },
                      },
                    },
                  },
                },
              },
            },
            images: {
              populate: {
                image: {
                  populate: "*",
                },
              },
            },
          },
        },
        "sections.events-slider": {
          populate: {
            events: {
              populate: "*",
            },
          },
        },
        "sections.about-more": {
          populate: {
            cards: {
              populate: "*",
            },
          },
        },
        "sections.how-to-get-section": {
          populate: {
            items: {
              populate: {
                icon: {
                  populate: "*",
                },
              },
            },
            button: {
              populate: {
                pageIcon: {
                  populate: {
                    icon: {
                      populate: "*",
                    },
                    uicon: {
                      populate: "*",
                    },
                  },
                },
              },
            },
            cities: {
              populate: {
                icons: {
                  populate: "*",
                },
              },
            },
          },
        },
        "sections.grid-media-list": {
          populate: {
            media_posts: {
              populate: {
                textContent: {
                  populate: {
                    author: {
                      populate: "*",
                    },
                    platformIcon: {
                      populate: "*",
                    },
                  },
                },
                mediaContent: {
                  populate: "*",
                },
              },
            },
          },
        },
        "sections.main-about-section": {
          populate: {
            background: {
              populate: {
                image: {
                  populate: "*",
                },
                video: {
                  populate: "*",
                },
              },
            },
            buttons: {
              populate: {
                pageIcon: {
                  populate: {
                    icon: {
                      populate: "*",
                    },
                    uicon: {
                      populate: "*",
                    },
                  },
                },
              },
            },
          },
        },
        "sections.art-sections": {
          populate: {
            artSections: {
              populate: {
                icon: {
                  populate: {
                    uicon: {
                      populate: "*",
                    },
                    icon: {
                      populate: "*",
                    },
                  },
                },
                bigIcon: {
                  populate: {
                    uicon: {
                      populate: "*",
                    },
                    icon: {
                      populate: "*",
                    },
                  },
                },
                smallImage: {
                  populate: "*",
                },
                mainImage: {
                  populate: "*",
                },
                media_post: {
                  populate: {
                    mediaContent: {
                      populate: "*",
                    },
                  },
                },
              },
            },
          },
        },
        "sections.cultural-objects-slider": {
          populate: {
            cultural_objects: {
              populate: {
                backgroundImage: {
                  populate: "*",
                },
                gallerySection: {
                  populate: {
                    gallery: {
                      populate: {
                        backgroundMedia: {
                          populate: {
                            image: {
                              populate: "*",
                            },
                            video: {
                              populate: "*",
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        "sections.slider-section": {
          populate: {
            sliders: {
              populate: {
                button: {
                  populate: "*",
                },
                buttonIcon: {
                  populate: {
                    icon: {
                      populate: "*",
                    },
                    uicon: {
                      populate: "*",
                    },
                  },
                },
                sliderCards: {
                  populate: {
                    icon: {
                      populate: {
                        uicon: {
                          populate: "*",
                        },
                        icon: {
                          populate: "*",
                        },
                      },
                    },
                    image: {
                      populate: "*",
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    hero: {
      populate: {
        AITexts: {
          populate: "*",
        },
        heroSlide: {
          populate: {
            title: {
              populate: {
                titleIconSettings: {
                  populate: {
                    icon: {
                      populate: {
                        uicon: {
                          populate: "*",
                        },
                        icon: {
                          populate: "*",
                        },
                      },
                    },
                  },
                },
              },
            },
            backgroundImage: {
              populate: "*",
            },
            backgroundImageMobile: {
              populate: "*",
            },
          },
        },
      },
    },
    seo: {
      populate: {
        ogImage: {
          populate: "*",
        },
      },
    },
  },
};

export const HTGParams = {
  populate: {
    items: {
      populate: {
        icon: {
          populate: "*",
        },
      },
    },
    button: {
      populate: {
        pageIcon: {
          populate: {
            icon: {
              populate: "*",
            },
            uicon: {
              populate: "*",
            },
          },
        },
      },
    },
    cities: {
      populate: {
        icons: {
          populate: "*",
        },
      },
    },
  },
};
